(function () {
  'use strict';
  const service = window.BodycareCart;
  if (!service || customElements.get('bodycare-cart-gift')) return;
  let normalizing = null;
  const managed = item => !!item.properties?._bodycare_free_gift;
  function validGift(item, config) {
    return config?.enabled && config.selectionEnabled && service.confirmedGift(item, config.title) &&
      config.products?.some(p => p.variants.some(v => String(v.id) === String(item.variant_id) && v.available));
  }
  service.ensureGiftsValid = async function () {
    if (normalizing) return normalizing;
    normalizing = service.transaction(async () => {
      const config = service.cart?.__bodycareGift;
      let kept = false;
      for (const item of [...(service.cart?.items || [])]) {
        if (!managed(item)) continue;
        if (!kept && validGift(item, config)) { kept = true; continue; }
        await service.setQuantity(item.key, 0, { source: 'gift-validation' });
        service.status('Your gift was removed because this offer no longer applies.');
      }
    }).finally(() => { normalizing = null; });
    return normalizing;
  };
  class BodycareCartGift extends HTMLElement {
    connectedCallback() {
      if (!this.bound) { this.addEventListener('click', this.onClick.bind(this)); this.bound = true; }
      this.read();
    }
    read(previous) {
      const node = this.querySelector('[data-gift-config]');
      if (!node) return;
      try { this.config = JSON.parse(node.textContent); } catch { return; }
      this.selected = (service.cart?.items || []).find(i => managed(i) && validGift(i, this.config));
      const eligible = this.config.eligible || !!this.selected;
      if (!eligible) this.expanded = false;
      else if (this.selected) this.expanded = false;
      else if (!previous || !previous.eligible || previous.selected) this.expanded = true;
      this.eligible = eligible;
      this.paint();
    }
    updateFrom(next) {
      const previous = { eligible: this.eligible, selected: !!this.selected };
      this.innerHTML = next.innerHTML; this.read(previous);
    }
    paint() {
      if (!this.config) return;
      const c = this.config; const amount = Math.max(0, Number(c.amount) || 0); const threshold = Math.max(1, Number(c.threshold) || 99900);
      this.classList.toggle('bc-cart-gift--unlocked', this.eligible);
      this.querySelector('[data-gift-heading]').textContent = this.selected ? c.selectedText : this.eligible ? c.unlockedText : 'FREE gift on ' + service.money(threshold) + '+';
      this.querySelector('[data-gift-message]').textContent = this.selected ? 'Your chosen gift is in your bag' : this.eligible ? 'Choose any 1 gift' : c.lockedText.replaceAll('[amount]', service.money(Math.max(0, threshold - amount)));
      const toggle = this.querySelector('[data-gift-toggle]');
      toggle.setAttribute('aria-expanded', String(!!this.expanded));
      toggle.firstChild.textContent = (this.selected ? 'Change' : this.expanded ? c.hideLabel : c.previewLabel) + ' ';
      this.querySelector('[data-gift-chevron]').textContent = this.expanded ? '⌃' : '⌄';
      this.querySelector('[data-gift-choices]').hidden = !this.expanded;
      const progress = this.querySelector('[data-gift-progress]');
      progress.value = this.eligible ? threshold : Math.min(amount, threshold);
      this.querySelector('[data-gift-current]').textContent = service.money(amount);
      this.querySelectorAll('[data-gift-choose]').forEach(button => { button.disabled = !this.eligible || !c.selectionEnabled || !!this.working; });
      const selectedRow = this.querySelector('[data-gift-selected]'); selectedRow.hidden = !this.selected || !!this.expanded;
      if (this.selected) {
        const product = c.products.find(p => p.variants.some(v => String(v.id) === String(this.selected.variant_id)));
        this.querySelector('[data-gift-selected-title]').textContent = product?.title || this.selected.product_title;
      }
      if (!c.selectionEnabled && this.expanded) this.notice('Gift selection will be available after checkout compatibility is verified.');
    }
    notice(text) { const node = this.querySelector('[data-gift-notice]'); if (node) node.textContent = text; }
    async onClick(event) {
      const toggle = event.target.closest('[data-gift-toggle], [data-gift-change]');
      if (toggle) { event.preventDefault(); this.expanded = !this.expanded; this.paint(); return; }
      const remove = event.target.closest('[data-gift-remove]');
      const choose = event.target.closest('[data-gift-choose]');
      if ((!remove && !choose) || this.working) return;
      event.preventDefault();
      if (choose && (!this.eligible || !this.config.selectionEnabled || choose.disabled)) return;
      this.working = true; this.paint(); this.setAttribute('aria-busy', 'true');
      try {
        await service.whenIdle();
        await service.transaction(async () => {
          for (const item of [...(service.cart?.items || [])].filter(managed)) await service.setQuantity(item.key, 0, { source: 'gift' });
          if (remove) return;
          const select = this.querySelector('[data-gift-variant][data-product=\"' + choose.dataset.product + '\"]');
          const variant = Number(select?.value || choose.dataset.variant);
          await service.add([{ id: variant, quantity: 1, properties: { _bodycare_free_gift: this.config.offerKey } }], { source: 'gift' });
          const item = service.cart?.items.find(i => managed(i) && Number(i.variant_id) === variant);
          if (!validGift(item, service.cart?.__bodycareGift)) {
            if (item) await service.setQuantity(item.key, 0, { source: 'gift' });
            throw new Error('This gift could not be applied with your current offers. Choose another or continue to checkout.');
          }
        });
        this.read({ eligible: this.eligible, selected: !!remove });
        this.notice(remove ? 'Gift removed. You can choose another or continue to checkout.' : 'Your free gift has been added.');
      } catch (error) {
        this.read({ eligible: this.eligible, selected: false });
        this.notice(error.message);
      } finally {
        this.working = false; this.removeAttribute('aria-busy'); this.paint();
      }
    }
  }
  customElements.define('bodycare-cart-gift', BodycareCartGift);
  document.addEventListener('bodycare:cart-content:rendered', () => {
    if (!normalizing && (service.cart?.items || []).some(managed)) service.ensureGiftsValid().catch(error => service.status(error.message, true));
  });
  if ((service.cart?.items || []).some(managed)) service.ensureGiftsValid().catch(error => service.status(error.message, true));
})();
